var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guanggaocard has-text-left"},[_c('span',{staticClass:"tag is-white guangaoicon"},[_vm._v("广告")])])}]

export { render, staticRenderFns }